<p *ngIf="!cover" class="text-center" [ngClass]="{'padded-top-30': topPadding}">
<fa-icon [spin]="true" [size]="'3x'" [icon]="faCircleNotch"></fa-icon>
</p>

<div *ngIf="cover" class="loading-wrapper">
  <div>
    <fa-icon class="selection-text-color" [spin]="true" [size]="'3x'"  [icon]="faCircleNotch"></fa-icon>
  </div>
</div>